import HttpClientToken from '../../services/HttpClientToken';

import { AutoridadExhortoLibradoProps, defaultAutoridadExhortoLibrado } from '../../interfaces/catalogos/AutoridadExhortoLibradoInterface';

export const AutoridadesExhortoLibrado = () => {

    return new Promise<AutoridadExhortoLibradoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadExhortoLibrado/', token)
            .then( ({ data } : { data : AutoridadExhortoLibradoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerAutoridadExhortoLibrados = () => {

    return new Promise<AutoridadExhortoLibradoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadExhortoLibrado/ObtenerAutoridadExhortoLibrados', token)
            .then( ({ data } : { data : AutoridadExhortoLibradoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerAutoridadExhortoLibrado = ( id: number ) => {

    return new Promise<AutoridadExhortoLibradoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/AutoridadExhortoLibrado/ObtenerAutoridadExhortoLibrado/${ id }`, token)
            .then( ({ data } : { data : AutoridadExhortoLibradoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ActualizarAutoridadExhortoLibrado = ( params: AutoridadExhortoLibradoProps ) => {

    return new Promise<AutoridadExhortoLibradoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadExhortoLibrado/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadExhortoLibradoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadExhortoLibrado } );
            });

        }

    });

}

export const AgregarAutoridadExhortoLibrado = ( params: AutoridadExhortoLibradoProps ) => {

    return new Promise<AutoridadExhortoLibradoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadExhortoLibrado/Agregar', params, token)
            .then( ({ data } : { data : AutoridadExhortoLibradoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadExhortoLibrado } );
            });

        }

    });

}
